import React from 'react'
import Agregar from './agregar'
import Historial from './historial'
import EpicMenu from '../../componentes/Menus/EpicMenu'

const Vales = () => {

    return (
        <section>
            <div className='header'>
				<EpicMenu />
				<div className='inline'>Vales</div>
			</div>
            <Agregar />
            <Historial />
        </section>
    )
}

export default Vales